import useDerivative from './useDerivative';

export default function usePageTitle(title) {
  const d = useDerivative();
  document.title = `${title} - ${d.displayName}`;
}
